import posthog from "posthog-js";


export const postHogHandler = (event, data = {}) => {
    posthog.capture(event, {

      ...data,
    });
  };